import { defineComponent as _defineComponent } from 'vue'
import { LibraryTypeJS } from '@/apis/bujianStore/types'
import MBujianStore from '@/components/m-bujian-store/index.vue'
import virtualList from '@/components/materialTable'
import { bujianList } from '@/components/materialTable/src/config/tableConfig'
import router from '@/router'
import store from '@/store'
import { translate } from '@/util/commonFun'
import { buryPointApi } from '@/util/commonFuncs'
import { dealPreLayoutDataLabelID } from '@/util/dealPaibanData'
import { genOrderAddressInfo } from '@/util/plankCommonFuncs'
import { dealBatchBujian } from '@/views/newPaiban/util/bujianData'
import { uploadFiles } from '@/views/newPaiban/util/uploadFiles'
import axios from 'axios'
import { Message } from 'element-ui'
import { nanoid } from 'nanoid'
import { getCurrentInstance, reactive, ref } from 'vue'
import Vue from 'vue'

import { bujianSearchKeys } from '../config'
import MTemplate from './m-template.vue'
import getDate from './utils/getDate'


export default /*#__PURE__*/_defineComponent({
  __name: 'm-bujian',
  setup(__props) {

const currentComp: any = getCurrentInstance()?.proxy
const state = reactive({
  bujian: {
    list: [],
    filterList: [],
    searchKey: '',
    searchType: 'plankNum',
    page: { searchKey: '' },
  },
})
const isLoadingBujian = ref<boolean>(false)
const bujianStoreRef = ref<InstanceType<typeof MBujianStore>>()
// 是否正在进入排版
const isPaibanLoading = ref(false)
const loadingText = ref(translate('workShopPage.enterArrange'))

// 当前路由
const route = currentComp?.$route

// 获取补件列表
function getBujianList(url: string) {
  isLoadingBujian.value = true
  axios
    .get(url)
    .then(({ data }) => {
      let { plank } = data
      plank = genPartUniqueId(plank)
      state.bujian.list = plank
      state.bujian.filterList = plank
      isLoadingBujian.value = false
    })
    .catch((err) => {
      console.error(err)
      isLoadingBujian.value = false
    })
}
async function handleToPaiban(data: any[]) {
  buryPointApi('device_online', 'ref_start')
  isPaibanLoading.value = true
  const sampleData = genOrderAddressInfo(data)
  Reflect.deleteProperty(sampleData, 'designer')
  store.commit('setSampleTableData', sampleData)
  store.commit('setPreLayoutData', dealPreLayoutDataLabelID(data))
  router.push({
    path: '/materialList',
  })
}
// 查询补件
function searchBujian(key: string, type: string) {
  const list = state.bujian.list.filter((it) =>
    key ? (it[type as keyof typeof it] + '').includes(key) : true
  )
  state.bujian.filterList = list
}
// 获取补件列表
getBujianList(route.query.url)

// 生成唯一标识ID
function genPartUniqueId(list: any[], type = 'plank') {
  list.forEach((it) => {
    it.partUniqueId = nanoid()
    if (type === 'plank') {
      const { oRect } = it
      it.oSize = `${oRect.height}*${oRect.width}*${it.thick}`
    }
  })
  return list
}

function onSearch({ value, selectType }: { value: any; selectType: string }) {
  searchBujian(value.searchKey, selectType)
}

// 添加进补件仓库
async function handleAddToStore(part: any) {
  buryPointApi('device_online', 'add_to_rfe_store')
  const { orderId, oRect, thick } = part
  const result: any = {
    supplements_info: [],
    reason: '',
    duty: '',
    library_type: LibraryTypeJS.bujianStore,
  }
  const url = await new Promise<string>((resolve) => {
    uploadFiles(
      {
        plank: [part],
      },
      'plankFiles',
      (re: string) => {
        resolve(re)
      }
    )
  })
  const dealData = await dealBatchBujian(part, url)
  result.supplements_info.push(dealData)
  Vue.prototype.$token('/workshop/supplements', result, (res: any) => {
    if (res.status == 1) {
      const nowTime = getDate()
      Object.assign(part, {
        oid: orderId,
        create_time: nowTime,
        id: res.data.id,
        sizeStr: `${oRect.height}*${oRect.width}*${thick}`,
        render_url: route.query.url,
      })

      Message.success(translate('common.addSuccess'))
      // 添加补件到补件仓库
      bujianStoreRef.value?.addNewBujian(part)
    } else {
      Message.error(res.msg)
    }
  })
}
// 补件触发加载
function onStartLoading({
  msg,
  isLoading,
}: {
  msg: string
  isLoading: boolean
}) {
  loadingText.value = msg
  isPaibanLoading.value = isLoading
}

return { __sfc: true,currentComp, state, isLoadingBujian, bujianStoreRef, isPaibanLoading, loadingText, route, getBujianList, handleToPaiban, searchBujian, genPartUniqueId, onSearch, handleAddToStore, onStartLoading, MBujianStore, virtualList, bujianList, bujianSearchKeys, MTemplate }
}

})